import React from 'react';

import { SearchableSelect } from '../../inputs/select/searchableSelect';
import { SelectItem } from '../../inputs/select/select';
import { Container, Row } from '../styles';
import { SelectFilterPassedProps } from '../types';

interface SelectFilterProps extends Omit<SelectFilterPassedProps, 'type'> {
  value: string | string[];
  onChange: (value: string | string[]) => void;
}

export const SelectFilter = ({ value, options, onChange, placeholder, multiple = false }: SelectFilterProps) => {
  const handleChange = (items: SelectItem | SelectItem[]) => {
    if (multiple) {
      const nextItems = items as SelectItem[];
      onChange(nextItems.map((item) => item.key));
    } else {
      const nextItem = items as SelectItem;
      onChange(nextItem.key);
    }
  };

  const selectedItems = multiple
    ? (value as string[]).map((key) => options.find((option) => option.key === key))
    : options.find((option) => option.key === (value as string));

  return (
    <Container>
      <Row>
        <SearchableSelect<SelectItem, typeof multiple>
          value={selectedItems as SelectItem[]}
          items={options}
          placeholder={placeholder}
          onChange={handleChange}
          getItemLabel={(item) => item.label}
          multiple={multiple}
          closeDropdownOnSelect
        />
      </Row>
    </Container>
  );
};
